import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';  // to handle navigation

const Error = ({ errorMessage = "Something went wrong", errorCode = "500" }) => {
  const location = useLocation();
  const navigate = useNavigate();  // for programmatic navigation
  const resolvedErrorMessage = location.state?.errorMessage || errorMessage;
  const resolvedErrorCode = location.state?.errorCode || errorCode;

  const handleGoHome = () => {
    navigate('/dashboard/connected-platforms');
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="max-w-md w-full bg-white p-6 rounded-lg shadow-md text-center">
        <h1 className="text-4xl font-bold text-red-600 mb-4">Error {resolvedErrorCode}</h1>
        <p className="text-lg text-gray-700 mb-6">{resolvedErrorMessage}</p>
        <div className="flex justify-center gap-4">
          <button
            onClick={handleGoHome}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default Error;
